import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var otpRes;
export const otpTodo = createAsyncThunk('otp', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'otp_verify',
            data: {
                "email": data?.email,
                "otp": data?.otp
            },
            headers: { "Content-Type": "application/json" }
        })
        return otpRes = res

    } catch (error) {
        return otpRes = error.response
    }
})